"use client";
import Link from "next/link";
import "./style.css";
interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumbs({ items }: BreadcrumbsProps) {
  return (
    // <div className="">
      <nav aria-label="Breadcrumb" >
        <ol className="gh-breadcrumbs">
          {items.map((item, index) => {
            const isLast = index === items.length - 1;

            return (
              <li
                key={index}
                className="gh-breadcrumb-item"
                aria-current={isLast ? "page" : undefined}
              >
                {item.href && !isLast ? (
                  <Link
                    href={item.href}
                    className="gh-breadcrumb-link"
                    aria-label={`Go to ${item.label}`}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <span className="gh-breadcrumb-current">{item.label}</span>
                )}

                {!isLast && (
                  <span className="gh-breadcrumb-separator" aria-hidden="true">
                    <svg
                      width="6"
                      height="10"
                      viewBox="0 0 6 10"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M1 1L5 5L1 9"
                        stroke="currentColor"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </span>
                )}
              </li>
            );
          })}
        </ol>
      </nav>
    // </div>
  );
}
